module.exports = __webpack_public_path__ + "static/prodinity_main_5-3b97be4d43ce7d10a3044cdf76645086.png";